import { SET_TRADING_VOLUME_DATA, SET_CAPITAL_LOCKED_DATA, SET_BLOCK_HEIGHT } from "../constants";

// Constants
// the block height is loaded and refreshed by App
const initialState = {
  tradingVolume: "-",
  capitalLocked: "-",
  blockheight: null,
};

// Reducer
export default function chatReducer(state = initialState, action) {
  switch (action.type) {
    case SET_TRADING_VOLUME_DATA:
      return { ...state, tradingVolume: action.payload };
    case SET_BLOCK_HEIGHT:
      return { ...state, blockheight: action.payload };
    case SET_CAPITAL_LOCKED_DATA:
      return { ...state, capitalLocked: action.payload };
    default:
      return state;
  }
}
